import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Promokode {{code}} anvendt',
  [COUPON_TYPES.CASHBACK]: 'Loyalitetspoint anvendt',
  [COUPON_TYPES.REWARD]: 'Belønning anvendt',
  [COUPON_TYPES.GIFT_CARD]: 'Gavekort anvendt',
};

export default Coupons;
